module.exports = __webpack_public_path__ + "static/media/prize-card.baa4d9eb.png";